import { render, staticRenderFns } from "./CrgoVoyage.vue?vue&type=template&id=0762fb88&"
import script from "./CrgoVoyage.vue?vue&type=script&lang=js&"
export * from "./CrgoVoyage.vue?vue&type=script&lang=js&"
import style0 from "./CrgoVoyage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CrgoVoyage.vue"
export default component.exports